import type { KayaState } from "./types";

/**
 * The two marks a day can carry on its day sheet (ADR-049).
 *
 * - **Untracked**: some of the day's food was not logged. What was logged stays, and the day is
 *   kept out of every average — a half-logged day read as a real one invents a deficit.
 * - **Fast day**: a fast the person chose. No deficit that day (`eating.ts::deficitRule`), kept
 *   out of the averages, and never counted as a missed day.
 *
 * A day carries one mark at most: both answer "why this day does not count", and the writers in
 * `store/toggles.ts` clear one when the other is set. This module only reads them, and imports
 * nothing but types, so `eating.ts` can read a fast day without a cycle through `intake.ts`.
 */

export type DayMark = "untracked" | "fast";

export function isUntracked(S: KayaState, ds: string): boolean {
  return !!S.untrackedDates?.[ds];
}

export function isFastDay(S: KayaState, ds: string): boolean {
  return !!S.fastDates?.[ds];
}

/** The day's mark, or null. A fast day wins if an older build ever left both set. */
export function dayMark(S: KayaState, ds: string): DayMark | null {
  if (isFastDay(S, ds)) return "fast";
  if (isUntracked(S, ds)) return "untracked";
  return null;
}
